import { IStoreState } from 'store';
import { concatArrays, getMfgMarkers } from 'components/formula-entry/modals/helpers';

export const getAllMarkersList = (state: IStoreState) => {
  const { dealEdit, costFormulas, formulaEntry } = state;
  const { formulas } = dealEdit;
  const { availableMarkers } = formulaEntry;
  const { data } = costFormulas;
  const mfgMarkers = getMfgMarkers(data);
  return concatArrays({ formulas, availableMarkers, mfgMarkers });
};
